(() => {
  const trigger = document.querySelector('.search-link');
  const dialog = document.getElementById('ps-search-dialog');
  if (!trigger || !dialog) return;
  const input = document.getElementById('ps-search-input');
  const results = document.getElementById('ps-search-results');
  const status = document.getElementById('ps-search-status');
  const initial = results.innerHTML;
  let timer, request;
  trigger.setAttribute('aria-haspopup', 'dialog');
  trigger.setAttribute('aria-controls', dialog.id);
  trigger.addEventListener('click', event => {
    event.preventDefault();
    document.querySelectorAll('.nav-disclosure').forEach(item => { item.open = false; });
    document.getElementById('navigation').classList.remove('open');
    document.querySelector('.menu-toggle').setAttribute('aria-expanded', 'false');
    dialog.showModal(); input.focus();
  });
  document.getElementById('ps-search-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('keydown', event => {
    if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); dialog.close(); }
  });
  dialog.addEventListener('close', () => { clearTimeout(timer); request?.abort(); results.removeAttribute('aria-busy'); trigger.focus(); });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const r = dialog.getBoundingClientRect();
    if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
  });
  input.addEventListener('input', () => {
    clearTimeout(timer); request?.abort();
    const query = input.value.trim();
    if (!query) { results.innerHTML = initial; results.removeAttribute('aria-busy'); status.textContent = 'Popular products'; return; }
    status.textContent = 'Searching…'; results.setAttribute('aria-busy', 'true');
    timer = setTimeout(async () => {
      request = new AbortController();
      const params = new URLSearchParams({ q: query, 'resources[type]': 'product,collection,page,article,query', 'resources[limit]': '6', section_id: 'photo-story-search' });
      try {
        const response = await fetch(`${dialog.dataset.suggestUrl}?${params}`, { signal: request.signal });
        if (!response.ok) throw new Error('Search unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const section = html.querySelector('#shopify-section-photo-story-search');
        if (!section) throw new Error('Missing search results');
        if (input.value.trim() !== query) return;
        results.innerHTML = section.innerHTML;
        status.textContent = `${results.querySelectorAll('.ps-search-product').length} products found for ${query}`;
      } catch (error) {
        if (error.name === 'AbortError') return;
        results.textContent = 'Suggestions are unavailable. Press Search to see all results.';
        status.textContent = results.textContent;
      } finally { if (input.value.trim() === query) results.removeAttribute('aria-busy'); }
    }, 250);
  });
})();
